wbApp.controller('CoursesAttendanceCtrl', ['$scope', '$translate', '$q', '$filter', 'courseScheduleSvc', 'attendanceSvc', 'gridSortSvc',
function ($scope, $translate, $q, $filter, courseScheduleSvc, attendanceSvc, gridSortSvc) {

    var selectedCourse = null;
    var isActive = false;
    var loaded = false;
    $scope.courseAttendance = [];

    function reloadData(refresh) {
        if (selectedCourse) {
            var schedules = courseScheduleSvc.getAllAsync(selectedCourse.courseID, refresh);
            var attendance = attendanceSvc.getAllForCourse(selectedCourse.courseID);
            $q.all([schedules.$promise, attendance.$promise]).then(function (res) {
                $scope.courseAttendance = attendanceSvc.prepareFullCourseAttendanceTable(attendance, schedules);

                setGridColumns($scope.courseAttendanceGridSettings, schedules);
                loaded = true;
            });
            
        }
    }

    function onCourseScheduleChanged(refresh) {
        reloadData(refresh);
        $scope.$emit('onCourseShouldRefresh', { course: $scope.selectedCourse });
    }

    $scope.$on('selectedCourseChanged', function (e, courseInd) {
        if (courseInd.course) {
            if (isActive) {
                if (selectedCourse !== courseInd.course || courseInd.refresh) {
                    selectedCourse = courseInd.course;
                    reloadData(courseInd.refresh);
                }
                loaded = true;
            } else {
                loaded = false;
            }
        } else {            
            $scope.courseAttendance = [];
        }
        selectedCourse = courseInd.course;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 3) {
            if (!isActive) {
                isActive = true;
                if (!loaded && selectedCourse) {
                    reloadData();
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.courseAttendanceGridSettings = {
        name: 'courseAttendance',
        columnFixing: { 
            enabled: true
        },
        columns: [{
            dataField: 'fullName',
            caption: $translate.instant('TXT_LBL_STUDENT'),
            dataType: 'string',
            sortOrder: 'asc',
            sortIndex: 1,
            fixed: true,
            width: '190px',
            calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'fullName') }
        }, {
            dataField: 'isRegistered',
            caption: $translate.instant('TXT_LBL_REGISTERED'),
            sortOrder: 'desc',
            sortIndex: 0,
            visible: false
        }],
        showColumnLines: true,
        showRowLines: true,
        onCellPrepared: function (e) {
            var visibleColumnIndex = e.columnIndex + 1; // TODO

            if (e.rowType === "data" && visibleColumnIndex > 1) {
                e.cellElement.mousemove(function () {
                    var dataField = $scope.courseAttendanceGridSettings.gridInstance.columnOption(visibleColumnIndex, 'dataField'); // $scope.courseAttendanceGridSettings.columns[visibleColumnIndex].dataField;
                    var attendanceStatusStr = $filter('attendanceStatus')(e.data[dataField].attendanceStatus);
                    var attendanceTypeStr = $filter('attendanceType')(e.data[dataField].attendanceType);
                    var msg = !!attendanceTypeStr ? attendanceTypeStr + "\n" + attendanceStatusStr : '';
                    e.cellElement.attr('title', msg);
                });
            }

            if (e.rowType === "data" && e.columnIndex === 0) {              
                if (e.data.isRegistered) {
                    e.cellElement.addClass('bold');
                }
            }
        }
    }

    function setGridColumns(gridSettings, schedules) {
        if (gridSettings.gridInstance) {

            gridSettings.gridInstance.beginUpdate();

            var colCount = gridSettings.gridInstance.columnCount();
            for (var i = colCount - 1; i >= 2; i--) {
                gridSettings.gridInstance.deleteColumn(i);
            }

            var sortedSchedules = _.orderBy(schedules, 'startDate');
            _.forEach(sortedSchedules, function (schedule) {
                gridSettings.gridInstance.addColumn({
                    dataField: schedule.courseScheduleID,
                    caption: $filter('date')(schedule.startDate, 'shortDate'),
                    width: '65px',
                    alignment: 'center',
                    calculateCellValue: function (rowData) {
                        //Present = 0,
                        //NotPresentNotExcused = 1,
                        //NotPresentExcused = 2,
                        //NotPresentExcusedNoCompensation = 3
                        var model = rowData[schedule.courseScheduleID] || { attendanceStatus: null };

                        switch (model.attendanceStatus) {
                            case null:
                                return '';
                            case 0:
                                return '|';
                            case 1:
                                return 'X';
                            case 2:
                                return 'O';
                            case 3:
                                return 'PO'
                        }
                    }
                });
            });

            gridSettings.gridInstance.addColumn({
                dataField: null,
                caption: ' '
            });

            gridSettings.gridInstance.endUpdate();
        }
    }
}]);
